<template>
  <div>
    <transition name="modal-fade">
      <div v-if="visible" class="modal-container">
        <div
          class="modal fade show d-block"
          tabindex="-1"
          aria-modal="true"
          role="dialog"
        >
          <div 
            class="modal-dialog modal-dialog-centered" 
            :class="[sizeClass]"
            :style="{ 
              'margin-top': topOffset, 
              'width': customWidth ? customWidth : null,
              'max-width': customMaxWidth ? customMaxWidth : null,
              'max-height': customHeight ? customHeight : null
            }"
          >
            <div 
              class="modal-content rounded-3"
              :style="{ 
                'max-height': customHeight ? customHeight : null,
                'height': customHeight ? '100%' : null
              }"
            >
              <div class="modal-header">
                <h5 class="modal-title" v-if="title">{{ title }}</h5>
                <button
                  v-if="showCloseBtn"
                  type="button"
                  class="btn-close"
                  @click="handleClose"
                  aria-label="Close"
                >
                  <img :src="closeIcon" alt="close" class="icon-20 cursor-pointer" />
                </button>
              </div>
              <div
                class="modal-body py-4"
                :style="{
                  'overflow-y': customHeight ? 'auto' : null,
                  'max-height': customHeight ? 'calc(100% - 9rem)' : null
                }"
              >
                <slot></slot>
              </div>
              <div  v-if="showButton" class="modal-footer d-flex justify-content-end gap-[0.5rem] pt-3">
                <button
                  v-if="showCancelButton"
                  type="button"
                  class="btn btn-secondary min-w-[9rem] ripple-surface"
                  @click="handleClose"
                >
                  {{ cancelButtonText }}
                </button>
                <button
                  v-if="showConfirmButton"
                  type="button"
                  class="btn btn-primary min-w-[9rem] ripple-surface"
                  :class="$attrs.confirmBtnClass"
                  :disabled="confirmButtonDisabled"
                  @click="handleConfirm"
                >
                  {{ confirmButtonText }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { watch, computed } from 'vue'
import closeIcon from 'url:../../../../assets/models/icons/close.svg'

defineOptions({
  name: 'ScanatModal'
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  },
  showConfirmButton: {
    type: Boolean,
    default: true
  },
  confirmButtonDisabled: {
    type: Boolean,
    default: false
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  confirmButtonText: {
    type: String,
    default: 'OK'
  },
  cancelButtonText: {
    type: String,
    default: 'Cancel'
  },
  showButton: {
    type: Boolean,
    default: true
  },
  showCloseBtn: {
    type: Boolean,
    default: true,
  },
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: '',
    validator: (val) => ['sm', 'lg', 'xl', ''].includes(val)
  },
  topOffset: {
    type: String,
    default: '0px'
  },
  customWidth: {
    type: String,
    default: ''
  },
  customMaxWidth: {
    type: String,
    default: ''
  },
  customHeight: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:visible', 'confirm', 'cancel'])
// 计算尺寸类名
const sizeClass = computed(() => {
  if (!props.size) return ''
  return `modal-${props.size}`
})

watch(() => props.visible, (val) => {
  if (val) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
})

const handleClose = () => {
  emit('update:visible', false)
  emit('cancel')
}

const handleConfirm = () => {
  emit('confirm')
  if (!props.closeOnClickModal) return
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1060;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  border: none;
  /* box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); */
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #E5E6EB !important;
}

.modal-title {
  color: #1D2129;
  font-weight: 500;
}

.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  background: transparent;
  opacity: 1;
}

.btn-close:focus {
  box-shadow: none;
}

.btn-close img {
  display: block;
}

.modal-body {
  color: #1D2129;
  font-size: 1rem;
  padding: 1rem 1.5rem;
  min-height: 120px;
}

.modal-footer {
  padding: 0.75rem 2rem;
  border-top: 1px solid #E5E6EB !important;
}

.confirm-btn {
  min-width: 9rem;
  font-size: 0.875rem;
  padding: 0.5rem 1.5rem;
  border-radius: 0.25rem;
}

.cancel-btn {
  min-width: 9rem;
  font-size: 0.875rem;
  padding: 0.5rem 1.5rem;
  border-radius: 0.25rem;
  background-color: #D8E8FF;
  color: #0068B0;
}
</style> 